export default function(fn,duration=1000){
	
	let timerId;
	return function(...args){
		if(timerId){
			clearTimeout(timerId)
		}
		
		timerId = setTimeout(()=>{
			fn.call(this,...args)
		},duration)
		
	}
}